<template>
    <div>
        <v-carousel
            v-if="items && items.length > 0"
            hide-delimiters
            :height="dimension.height"
            :show-arrows="items.length > 1 ? true : false"
        >

            <v-carousel-item
                v-for="item in items"
                :key="item.id"
            >
                <v-img
                    :src="item.urlremoto"
                    :lazy-src="item.urlremoto"
                    height="100%"
                    cover
                    class="position-relative" 
                    @click="check"
                >

                    <!-- Botão no canto superior direito -->
                    <!--div class="favorite-icon" v-if="props.favorites">
                        <v-tooltip text="Adicionar aos favoritos" aria-hidden="false" aria-label="favorites">
                            <template v-slot:activator="{ props }">
                                <v-icon 
                                    @click.stop
                                    v-bind="props" 
                                    :class="{
                                        'favorite': checkFavorite(object), 
                                        'not-favorite': !checkFavorite(object)
                                    }"
                                    @click.prevent="addDeleteFavorite(object)" 
                                    aria-label="ver_imovel" 
                                    role="img" 
                                    aria-hidden="false" 
                                >
                                    mdi-heart
                                </v-icon>
                            </template>
                        </v-tooltip>
                    </div-->


                    <v-chip 
                        v-if="item.description != null" 
                        color="shop_window_chip_background" 
                        variant="flat" 
                        class="ma-2"
                        text-color="shop_window_chip_text"
                    >
                        <v-icon left class="mr-1">
                            mdi-label
                        </v-icon>

                        {{ item.description }}
                    </v-chip>


                    <template v-slot:placeholder>
                        <div class="d-flex align-center justify-center fill-height" style="background-color: #e1e1e1;">
                            <v-progress-circular
                                color="grey-lighten-4"
                                indeterminate
                            ></v-progress-circular>
                        </div>
                    </template>
                </v-img>
            </v-carousel-item>
        </v-carousel>

        <v-card v-else elevation="0" color="#dadada" class="text-center" height="100%">
            <v-avatar
                rounded="0"
                :size="dimension.height"
            >
                <v-icon color="#BDBDBD" :size="dimension.height">
                    mdi-home
                </v-icon>

            </v-avatar>
        </v-card>

    </div>
</template>

<script>
export default {
    props: {
        items: {
            type: Array, // Adicione o tipo
            required: false, // Corrigido: "required" em vez de "require"
            default: () => [] // Adicione um valor padrão para arrays
        },

        dimension: {
            type: Object, // Adicione o tipo
            required: false, // Corrigido: "required" em vez de "require"
            default: () => ({
                height: 220
            })
        }    
    },

    methods: {
        check(){

        }
    }
}
</script>